<template>
<div>
  <div v-if="isMaxScreen" class="pc_language" @click.stop="handleSelectLanguage">
    {{ localeMapping[lang].name }}
    <div v-show='showLanguageList' class="language-list-box">
      <div v-for="(item, key) in localeMapping" :key="`lang-${key}`" :class="['language-item',{'selected': lang === item.value}]" @click.stop="handleChangeLanguage(item)">{{ item.name }}</div>
    </div>
  </div>
  <div v-else class="language" @click.stop="handleSelectLanguage">
    {{ localeMapping[lang].name }}
    <div v-show='showLanguageList' class="language-list-container">
      <div class="language-list-box">
        <div v-for="(item, key) in localeMapping" :key="`lang-${key}`" :class="['language-item',{'selected': lang === item.value}]" @click.stop="handleChangeLanguage(item)">
          <span>{{ item.name}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { localeMapping, lang } from '@/locales';
export default {
  name: 'language',
  components: { },
  data() {
    return {
      showLanguageList: false,
      lang,
      localeMapping
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      },
    }),
  },
  created(){
  },
  mounted(){},
  methods: {
    handleClick(){
      this.showLanguageList = false;
    },
    handleSelectLanguage(){
      this.showLanguageList = !this.showLanguageList
      this.$emit('handleSelectLanguage')
    },
    handleChangeLanguage(item){
      this.showLanguageList = false;
      this.currnetLang = item.name;
      this.$toggleLang(item.value);
    }
  }
}
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .pc_language{
    position: relative;
    color: #252629;
    font-family: "PingFang SC";
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    .language-list-box{
      position: absolute;
      left: -28px;
      top: 70px;
      border-radius: 4px;
      background: #FFF;
      box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.08);
      z-index: 1000;
      &::before{
        content: '';
        display: block;
        width: 0;
        height: 0;
        position: absolute;
        top: -7px;
        left: 30px;
        border-style: solid;
        border-width: 8px;
        border-color: #fff #fff transparent transparent;
        transform: rotate(-45deg);
        box-shadow: 3px -3px 5px -3px rgba(0, 0, 0, 0.25);
      }
      .language-item{
        padding: 14px 78px;
        color: #252629;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        &.selected{
          color: #FF9600;          
          background: #F7F7F7;
        }
        &:hover{
          background: #F7F7F7;
        }
      }
    }
    
    @media (max-width: 1700px) {
      .language-list-box{
        left: auto;
        right: -28px;
        &::before{
          left: auto;
          right: 30px;
        }
      }
    }
  }
}


@media (max-width: 980px) {
  .language{
    color: #252629;
    font-family: "PingFang SC";
    font-size: 28px;
    font-weight: 500;
    .language-list-container{
      position: absolute;
      right: 0;
      top: 101px;
      z-index: 999;
      width: 100%;
      height: calc(100vh - 100px);
      background: rgba(0, 0, 0, 0.6);
      .language-list-box{
        background: #FFF;
        .language-item{
          color: #252629;
          font-family: "PingFang SC";
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 44px;
          padding: 24px 30px;
          background: #FFF;
          &.selected{
            color: #FF9600;          
            background: #F7F7F7;
          }
        }
      }
    }
  }

}

</style>
